export var PositionType;

(function (PositionType) {
  PositionType["TOPRIGHT"] = "topright";
  PositionType["TOPLEFT"] = "topleft";
  PositionType["BOTTOMRIGHT"] = "bottomright";
  PositionType["BOTTOMLEFT"] = "bottomleft";
  PositionType["TOPCENTER"] = "topcenter";
  PositionType["BOTTOMCENTER"] = "bottomcenter";
  PositionType["LEFTCENTER"] = "leftcenter";
  PositionType["RIGHTCENTER"] = "rightcenter";
})(PositionType || (PositionType = {}));